import { checkForRemovedLinks } from './checkForRemovedLinks';
import { X_OWA_AUTO_LINKS_CLASSNAME } from './constants';
import { LinkIdContainer } from '../schema/LinkIdContainer';
import { OWA_AUTO_LINKS_CLASSNAME } from 'owa-compose-link';
import { format } from 'owa-localize';
import { trace } from 'owa-trace';
import { Editor } from 'roosterjs-editor-core';

export default async function getAllSharePointLinks(
    editor: Editor,
    linkIdContainer: LinkIdContainer
): Promise<void> {
    if (!editor) {
        return;
    }

    const existingLinkIdMap: { [key: string]: boolean } = {};
    getLinksBasedOnClassName(OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);
    getLinksBasedOnClassName(X_OWA_AUTO_LINKS_CLASSNAME, editor, existingLinkIdMap);

    checkForRemovedLinks(linkIdContainer, existingLinkIdMap);
}

function getLinksBasedOnClassName(
    className: string,
    editor: Editor,
    existingLinkIdMap: { [key: string]: boolean }
) {
    const allSPLinks = editor.queryElements('.' + className, link => {
        existingLinkIdMap[link.id] = true;
    });

    trace.info(format('getLinksBasedOnClassName: Found {0} SP links.', allSPLinks.length));
}
